import { KIND } from 'baseui/button'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import IconSmartphone from '@/shared/icons/NewDesign/IconSmartphone'
import type { ActivatedPanelProps } from '../types'
import { StyledButtonBlock } from '../styled-components'

const ActivatedPanel = ({ hidden, text, appLinksAction, appLinksOverrides }: ActivatedPanelProps) => {
  if (hidden) {
    return null
  }

  return (
    <>
      <SDNotification type='positive' iconType='check' primaryText={text} />
      <StyledButtonBlock hidden={appLinksAction.hidden}>
        {/* @ts-ignore */}
        <SDButton
          block={true}
          kind={KIND.secondary}
          overrides={appLinksOverrides}
          disabled={appLinksAction.disabled}
          isLoading={appLinksAction.loading}
          onClick={appLinksAction.onClick}
          startEnhancer={<IconSmartphone />}
        >
          {appLinksAction.label}
        </SDButton>
      </StyledButtonBlock>
    </>
  )
}

export default ActivatedPanel
